import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroPrimaryCallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="18569" id="hero-introduction" className="relative flex min-h-[80vh] w-full items-center justify-center overflow-hidden bg-background dark">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1595871/img/hero_illustration_background.png" alt="Technical Architectural Blueprint" className="h-full w-full object-cover object-center opacity-5" />
        <div className="absolute inset-0 bg-background/95 backdrop-blur-[1px]" />
        
        {}
        <div className="absolute -top-24 -left-24 h-96 w-96 rounded-full bg-primary/5 blur-3xl" />
        <div className="absolute -bottom-24 -right-24 h-96 w-96 rounded-full bg-accent/5 blur-3xl" />
      </div>

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="mx-auto max-w-5xl space-y-10">
          <h1 className="text-5xl font-black tracking-tighter text-foreground sm:text-7xl lg:text-8xl">
            Advance Your Career. <span className="text-primary">Get Certified.</span>
          </h1>
          
          <p className="mx-auto max-w-3xl text-xl font-normal text-foreground/80 leading-relaxed">
            Gain the competitive edge with professional certifications that validate your 
            technical expertise and accelerate your path to leadership in architectural design.
          </p>

          <div className="flex flex-col items-center justify-center gap-6 sm:flex-row">
            <Button asChild size="lg" className="h-14 px-10 text-lg font-semibold shadow-lg shadow-primary/20 rounded-lg bg-primary text-primary-foreground hover:opacity-90 transition-all">
              <Link to="/ContactPage">
                Get Certified
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="h-14 px-10 text-lg font-medium border-primary/30 bg-background/20 hover:bg-primary/10 backdrop-blur-md rounded-lg text-foreground">
              
            </Button>
          </div>
        </div>
      </div>
    </section>;
}